<script setup>
import { toRefs } from "vue";
import InfoHolder from "@/components/global/drawer/InfoHolder.vue";

const props = defineProps({
  job: {
    type: Object,
  },
});

const { job } = toRefs(props);
</script>

<template>
  <div v-if="Object.keys(job).length > 0" class="pa-5">
    <h1>{{ job.name }}</h1>
    <v-divider />
    <div class="d-flex box-holder">
      <div class="d-flex box-row flex-1-0-0">
        <div class="box-container mt-5">
          <h3 class="pa-2"><v-icon>mdi-briefcase</v-icon> Job Position Data</h3>
          <InfoHolder title="Title" :info="job.name" />

          <InfoHolder title="Position ID" :info="job.positionId" />

          <InfoHolder title="Company" :info="job.company?.name" />

          <InfoHolder
            title="Description"
            type="richText"
            :info="job.description"
          />

          <InfoHolder title="Status" :info="job.status?.name" />

          <InfoHolder
            title="Number of positions to cover"
            :info="job.numberOfPositions"
          />

          <InfoHolder title="Link" :info="job.link" />

          <InfoHolder title="Salary" :info="job.salary" />

          <InfoHolder
            title="How did we find the job position?"
            :info="job.foundWay?.name"
          />

          <InfoHolder
            title="How did we apply for the job post?"
            :info="job.applyWay?.name"
          />

          <InfoHolder title="Comments" :info="job.comment" />
        </div>
        <div class="d-flex" style="gap: 10px">
          <div class="box-container box-w3 mt-5">
            <h3 class="pa-2 d-flex align-center">
              <v-icon class="mr-1"> mdi-account-search-outline </v-icon>
              Selected Beneficiaries
            </h3>

            <div
              v-for="selected in job.selectedBeneficiaries"
              :key="selected.id"
              class="pa-2"
            >
              <router-link
                :to="'/beneficiary/intake/view/' + selected.id"
                target="_blank"
                class="chip-link-color-company"
              >
                <v-chip> {{ selected.name }} </v-chip>
              </router-link>
              <!-- <v-chip>
                {{ selected.name }}
              </v-chip> -->
            </div>
          </div>

          <div class="box-container box-w3 mt-5">
            <h3 class="pa-2 d-flex align-center">
              <v-icon class="mr-1"> mdi-account-alert-outline </v-icon> Matched
              Beneficiaries
            </h3>
            <div
              v-for="matched in job.matchedBeneficiaries"
              :key="matched.id"
              class="pa-2"
            >
              <router-link
                :to="'/beneficiary/intake/view/' + matched.id"
                target="_blank"
                class="chip-link-color-company"
              >
                <v-chip> {{ matched.name }} </v-chip>
              </router-link>
              <!-- <v-chip>{{ matched.name }}</v-chip> -->
            </div>
          </div>

          <div class="box-container box-w3 mt-5">
            <h3 class="pa-2 d-flex align-center">
              <v-icon class="mr-1"> mdi-account-check-outline </v-icon> Hired
              Beneficiaries
            </h3>

            <div
              v-for="hired in job.hiredBeneficiaries"
              :key="hired.id"
              class="pa-2"
            >
              <router-link
                :to="'/beneficiary/intake/view/' + hired.id"
                target="_blank"
                class="chip-link-color-company"
              >
                <v-chip> {{ hired.name }} </v-chip>
              </router-link>
              <!-- <v-chip>{{ hired.name }}</v-chip> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 48px;
  color: rgb(var(--v-theme-company));
}
.box-holder {
  gap: 20px;
  .box-row {
    flex-direction: column;
    .box-w3 {
      width: 100%;
    }
    .box-container {
      border: 1px solid rgb(var(--v-theme-company));
      h3 {
        background-color: rgb(var(--v-theme-company));
        color: white;
      }
      .info {
        .label {
          text-decoration: underline;
        }
        .answer {
          display: block;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
